/**
 * @file ProductImagePlaceholder.tsx
 * @description Фирменная заглушка для товара без фото (phase19.5).
 *
 * Inline-SVG «веточка чайного листа» в палитре DS Chaiberi Editorial:
 * кремовый фон (accent), оливковый контур (primary). Масштабируется под
 * контейнер (viewBox), используется в миниатюре таблицы и карточках списка.
 */

import { cn } from "@/lib/utils";

interface ProductImagePlaceholderProps {
  className?: string;
}

export function ProductImagePlaceholder({ className }: ProductImagePlaceholderProps) {
  return (
    <div
      role="img"
      aria-label="Фото товара отсутствует"
      className={cn(
        "flex items-center justify-center bg-accent overflow-hidden",
        className,
      )}
    >
      <svg
        viewBox="0 0 96 96"
        className="h-3/5 w-3/5 text-primary"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        {/* Стебель */}
        <path d="M50 84 C46 66 46 44 56 16" opacity="0.55" />
        {/* Листья слева (контур + лёгкая заливка) */}
        <path
          d="M48.5 70 C36 69 27 61 24.5 50 C37 51.5 46 59 48.5 70 Z"
          fill="currentColor"
          fillOpacity="0.14"
          opacity="0.55"
        />
        <path
          d="M48 48 C37.5 46.5 30.5 39 29 29.5 C39.5 31.5 46.5 38.5 48 48 Z"
          fill="currentColor"
          fillOpacity="0.14"
          opacity="0.55"
        />
        {/* Листья справа */}
        <path
          d="M50.5 58 C62 55.5 69.5 47.5 71 37 C59.5 39.5 52.5 47.5 50.5 58 Z"
          fill="currentColor"
          fillOpacity="0.14"
          opacity="0.55"
        />
        <path
          d="M53.5 34 C63 31.5 68.5 24.5 69.5 16.5 C60.5 19 54.5 25.5 53.5 34 Z"
          fill="currentColor"
          fillOpacity="0.14"
          opacity="0.55"
        />
      </svg>
    </div>
  );
}
